import React, { useEffect, useState } from "react";
import { Shell, Section } from "@/components/loomi/Layout";
import { ADMIN_NAV } from "./AdminDashboard";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({ name: "", contact_email: "", account_manager: "" });
  const [saving, setSaving] = useState(false);

  const load = async () => { const { data } = await api.get("/clients"); setClients(data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.post("/clients", form); toast.success("Client created"); setForm({ name: "", contact_email: "", account_manager: "" }); load(); }
    catch (err) { toast.error("Failed", { description: formatApiError(err) }); }
    finally { setSaving(false); }
  };

  return (
    <Shell title="Clients" portalLabel="Admin" nav={ADMIN_NAV}>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <Section title="All clients" testId="section-clients">
            {clients.length === 0 ? (
              <div className="text-mute text-sm py-8 text-center" data-testid="clients-empty">No clients yet.</div>
            ) : (
              <table className="w-full text-sm" data-testid="clients-table">
                <thead>
                  <tr className="text-left text-xs uppercase tracking-widest text-mute border-b border-white/10">
                    <th className="py-3 pr-4">Name</th><th className="py-3 pr-4">Contact</th><th className="py-3 pr-4">Account Manager</th>
                  </tr>
                </thead>
                <tbody>
                  {clients.map((c) => (
                    <tr key={c.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`client-row-${c.id}`}>
                      <td className="py-3 pr-4 font-medium">{c.name}</td>
                      <td className="py-3 pr-4 text-mute">{c.contact_email || "—"}</td>
                      <td className="py-3 pr-4 text-mute">{c.account_manager || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Section>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl p-6 h-fit rise-in-3" data-testid="new-client-form">
          <h3 className="font-display font-bold text-lg mb-4">New client</h3>
          <label className="block text-[10px] uppercase tracking-widest text-mute mb-1">Name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-client-name" className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2 mb-3 text-sm" />
          <label className="block text-[10px] uppercase tracking-widest text-mute mb-1">Contact email</label>
          <input type="email" value={form.contact_email} onChange={(e) => setForm({ ...form, contact_email: e.target.value })} data-testid="new-client-email" className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2 mb-3 text-sm" />
          <label className="block text-[10px] uppercase tracking-widest text-mute mb-1">Account manager</label>
          <input value={form.account_manager} onChange={(e) => setForm({ ...form, account_manager: e.target.value })} data-testid="new-client-am" className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2 mb-4 text-sm" />
          <button disabled={saving} data-testid="new-client-submit" className="w-full bg-indigo-500 hover:bg-indigo-400 disabled:opacity-60 rounded-md py-2 text-sm font-medium flex items-center justify-center gap-2">
            <Plus className="w-4 h-4" /> {saving ? "Saving…" : "Create client"}
          </button>
        </form>
      </div>
    </Shell>
  );
}
